// generated from 22_025 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const appVersionCodeByAppFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("app_version_code_by_app_filter"),
  comparison_key: z.enum([
    "4", // 17_483 (79.38%)
    "5", // 1_468 (6.67%)
    "2", // 1_177 (5.34%)
    "1", // 1_174 (5.33%)
    "6", // 363 (1.65%)
    "3", // 360 (1.63%)
  ]),
  display_name: z.object({
    // undefined: 22_022 (99.99%), defined 3 (0.01%)
    deleted_app: z.literal(true).optional(),
    id: common.objectId,
    value: z.string(),
  }),
  // undefined: 7_531 (34.19%), defined 14_494 (65.81%)
  raw_value: z.string().optional(),
  value: z.object({
    id: z.string(),
    value: z.string(),
  }),
  varies_by_app_group: z.literal(false),
});
